import authHeaders, {
  CALL_ABLE_PORTAL_API,
  CALL_ACCOUNT_SYSTEM_API,
  CALL_AUTHORIZATION_MANAGEMENT_API,
  CALL_CSR_API,
  CALL_FUNDS_DISTRIBUTION_API,
  CALL_INTERNAL_API,
  CALL_ORGANIZATIONS_API,
} from '../middleware/authHeaders'
import rootReducer from '../reducers/rootReducer'
import storeFactory from './storeFactory'

const store = storeFactory({
  middlewares: [
    authHeaders(CALL_INTERNAL_API),
    authHeaders(CALL_FUNDS_DISTRIBUTION_API),
    authHeaders(CALL_CSR_API),
    authHeaders(CALL_ACCOUNT_SYSTEM_API),
    authHeaders(CALL_ORGANIZATIONS_API),
    authHeaders(CALL_ABLE_PORTAL_API),
    authHeaders(CALL_AUTHORIZATION_MANAGEMENT_API),
  ],
  reducer: rootReducer,
})

// TODO: fix hot reload replacement
// if (module.hot) {
//   module.hot.accept('../reducers', () => {
//     const nextRootReducer = require('../reducers/rootReducer').default
//     store.replaceReducer(nextRootReducer)
//   })
// }

export default store
